module.exports = __webpack_public_path__ + "img/image-6.6d36fc81.png";